import React  from 'react';
import peijianxiao1 from '../assets/img/peijianxiao1.png';
import chefuxiao1 from '../assets/img/chefuxiao1.jpg';
import kachexiao1 from '../assets/img/kachexiao1.png';
import kechexiao1 from '../assets/img/kechexiao1.png';

const Enclosure51 = () => 
    <div
        style={{
            WebkitTouchCallout:'none',  /*系统默认菜单被禁用*/
            MozUserSelect: 'none',  /*火狐*/
            WebkitUserSelect: 'none',  /*webkit浏览器*/
            msUserSelect: 'none',  /*IE10*/
            khtmlUserSelect: 'none',  /*早期浏览器*/
            userSelect: 'none',
        }}
     >
        <div style={{ textIndent: '2em' }}>
            <h3 style={{fontWeight:'bold'}}>配件业务管理公司</h3>
            <img src={peijianxiao1} alt="" style={{
                width  : '100%',
                display: 'block',
                margin : '0 auto'
            }}/>
            <br/>
            <br/>
            <h3 style={{fontWeight:'bold'}}>云豪车服</h3>
            <img src={chefuxiao1} alt="" style={{
                width  : '100%',
                display: 'block',
                margin : '0 auto'
            }}/>
            <br/>
            <br/>
            <h3 style={{fontWeight:'bold'}}>卡车公司</h3>
            <img src={kachexiao1} alt="" style={{
                width  : '100%',
                display: 'block',
                margin : '0 auto'
            }}/>
            <br/>
            <br/>
            <h3 style={{fontWeight:'bold'}}>客车公司</h3>
            <img src={kechexiao1} alt="" style={{
                width  : '100%',
                display: 'block',
                margin : '0 auto'
            }}/>
            <br/>
            <br/><br/>
        </div>
    </div>


export default Enclosure51;